<template>
    <div>
      <div class="bodder-div content-div">
      <div class="title-div center">淘号号极速版用户服务协议</div>
      <div class="top20">【审慎阅读】您在申请注册登录流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、与您约定法律适用和管辖的条款、其他以粗体标识的重要条款。以上特别条款将以粗体标识，您应重点阅读。如您对协议有任何疑问，可向淘号号极速版平台客服咨询。</div>
      <div class="top20">【签约动作】当您按照页面提示阅读并同意本协议及《淘号号极速版隐私权条款》、使用手机号或微信登录且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容，并与淘号号极速版达成一致，成为淘号号极速版平台用户。阅读协议的过程中，如果您不同意协议或其中任何条款约定，您应立即停止注册。</div>
      <div class="top20">【重要须知】如您选择接受本协议并使用淘号号极速版平台服务的，您与淘号号极速版均应严格履行本协议所约定的各项内容，您因使用淘号号极速版平台服务所产生及与淘号号极速版平台服务有关的争议或纠纷，由淘号号极速版与您友好协商解决；协商不成的，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</div>
    <div class="top20">【特别提示】淘号号极速版平台包括淘号号极速版官网、淘号号极速版移动应用软件（APP）。阅读协议的过程中，如您不同意接受本协议的任意内容，或者无法准确理解相关条款含义的，您应立即停止注册、使用或其他后续操作程序，并销毁所有许可软件副本。</div>
    
    <div class="title-div top20">第一条  立约目的和签约主体</div>
    <div>1、 为规范淘号号极速版平台运营秩序，明确各方权利义务关系，保障各方合法权益，特制定本协议。</div>
    <div>2、本协议由用户（以下亦简称“您”）与淘号号极速版软件所有者及运营者深圳市字节狂飙科技有限公司（以下简称“本公司”或“淘号号极速版”）之间就您使用淘号号极速版平台服务等相关事宜所订立的契约，淘号号极速版将通过软件为您提供一个交易流转的平台。</div>
   
    <div class="title-div top20">第二条  协议生效和适用范围</div>
    <div>1、您通过淘号号极速版平台页面点击确认或以其他方式选择接受本协议并按照淘号号极速版登录程序成功登录，即表示您与淘号号极速版已达成协议并同意接受本协议的全部约定内容。本协议自您点击确认之时起生效，在您使用淘号号极速版服务期间持续有效。
  </div><div>2、本协议内容包括协议正文、《淘号号极速版隐私条款》以及所有淘号号极速版已经发布的或将来可能发布并采取合理途径提前七日通知您的各类规则、操作流程、行为规范。前述各类规则、协议等均可以通过淘号号极速版APP“我的”—“设置”—“关于淘号号极速版”中自行查阅，淘号号极速版有权以修改、更新等方式调整本协议和相关规则的内容，相关内容将公布于网站上或以其他方式通知您。除非您明示并通知淘号号极速版不愿接受调整后的内容并停止使用淘号号极速版及相关服务，否则调整后的内容将于公布之日起七日后开始对您生效</div>
   
  <div class="title-div top20">第三条  定义</div>
  <div>
  1、“淘号号极速版”：指深圳市字节狂飙科技有限责任公司旗下拥有并运营的交易平台。</div>
  <div>2、“淘号号极速版用户”：指享受淘号号极速版服务的用户，应当具备中华人民共和国法律规定的与您行为相适应的完全民事权利能力和民事行为能力。根据国家新闻出版署要求，淘号号极速版不对未成年人提供服务，实名认证环节不支持未成年人认证账户。</div>
  
   <div> 3、“用户注册”：是指用户进入淘号号极速版，通过手机号、微信账号授权登录并必须绑定手机号，按淘号号极速版要求填写相关信息并确认同意履行相关用户协议的过程。 </div>
  <div class="title-div top20">第四条  淘号号极速版客户端授权范围</div>
  <div>
  1、淘号号极速版基于本协议许可而非向您销售淘号号极速版客户端（以下简称“许可软件”），用户仅可依照本协议约定使用许可软件。淘号号极速版保留未明示授予的一切权利。淘号号极速版有权根据实际情况对许可软件及其相关功能进行变更、升级、修改或转移，并有权在许可软件系统中开发新的功能或其他服务，并不另行通知于您。除非附有独立的协议，否则上述所有新的功能、软件服务的提供仍适用本协议。
  </div><div>2、除您与淘号号极速版另有约定外，您同意淘号号极速版客户端的服务及相关的数据仅供您个人非商业性质的使用，或者将淘号号极速版作为从事商业活动的场所、平台或其他任何形式的媒介。您不得对许可软件服务的任何部分或对其使用及获得进行复制、拷贝、出售或利用许可软件服务进行调查、广告或将许可软件服务用于其他任何商业目的，也不得对许可软件或者许可软件运行过程中释放在任何终端中的数据及许可软件运行过程中终端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经授权的第三方工具/服务接入许可软件和相关系统。但淘号号极速版对特定服务另有使用指引或规则的除外。
  </div>
  <div>3、用户不得开发或委托第三方开发/使用应用软件或程序侵入淘号号极速版平台系统进行批量信息的抓取、下载或进行违背淘号号极速版平台产品规则的操作，否则淘号号极速版有权全额扣除用户缴纳的保证金（如有）或者直接抵扣用户在淘号号极速版平台的交易款项并要求用户对给淘号号极速版造成的全部损失承担赔偿责任。</div>
  <div>
  4、用户不得对许可软件的相关信息擅自出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，借助许可软件发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；不得删除许可软件及其他副本上关于版权的信息、内容；不得进行任何危害信息网络安全的行为，包括使用许可软件时以任何方式损坏或破坏许可软件或使其不能运行或超负荷或干扰第三方对许可软件的使用；不得进行未经允许进入他人软件系统并删除、修改、增加存储信息；不得故意传播恶意程序或病毒以及其他破坏、干扰正常网络信息服务的行为；不得利用许可软件发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，或从事欺诈、盗用他人账户、资金等违法犯罪活动。
  </div>
  <div>5、本公司为淘号号极速版平台向您提供的服务付出了大量的成本，除淘号号极速版平台明示的收费业务外，不会向您收取其他费用。如淘号号极速版向您收取合理费用，淘号号极速版会采取合理途径并以足够合理的期限提前通过法定程序并以本协议约定的方式通知您，确保您有充分选择的权利。
  </div><div>6、淘号号极速版有权基于您在平台的行为（包括信息发布、私信沟通、买卖交易等）对您进行身份及风控识别。当您被平台系统识别为平台专业卖家后，如不认证，则可以继续以普通用户身份发布商品，但每个品类有一定的在架数量限制。如您选择认证为专业卖家的，则可享受优于普通用户的权益（如在认证品类不限商品在架数量，及PC端管理后台（如有）的使用权益等。具体以平台页面展示为准，认证到期未续的，则立即恢复普通卖家身份。
  </div>
  <div class="title-div top20">第五条  淘号号极速版平台服务及规范</div>
  <div>
  1、您有权在淘号号极速版平台上享受交易或服务的购买与评价、交易争议处理等服务。您应如实描述商品/服务的情况，不得出现任何虚假、伪造、冒用等引人误解或有失公平的情况。</div>
  <div>
  2、您应当确保您对您在淘号号极速版平台上发布的商品或服务享有相应的权利，您不得在淘号号极速版平台上销售以下商品或提供以下服务：
  </div><div>（一）国家法律法规所禁止或限制的；
  </div><div>（二）侵犯他人知识产权或其它合法权益的；
  </div><div>（三）淘号号极速版平台规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在淘号号极速版平台上销售或提供的。</div>
  <div>
  3、当您在淘号号极速版平台购买商品或服务时，请您务必仔细确认所购商品的品名、价格、数量、规格、或服务的时间、内容、限制性要求等重要事项。您的购买行为应当基于真实、合法的消费需求，不得存在对商品或服务实施恶意购买、恶意维权等扰乱淘号号极速版平台正常交易秩序的行为。基于维护淘号号极速版平台交易秩序及交易安全的需要，淘号号极速版发现上述情形时可主动执行关闭相关交易订单等操作。
  </div><div>4、您有权在淘号号极速版平台提供的评价系统中对与您达成交易的其他用户商品或服务进行评价。您应当理解，您在淘号号极速版平台的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，请勿进行评价。您的所有评价行为应遵守淘号号极速版平台规则的相关规定，评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。淘号号极速版可按照淘号号极速版平台规则的相关规定对您实施上述行为所产生的评价信息进行删除或屏蔽。</div>
  
  <div>
  5、平台担保服务：用户知悉并同意，当用户因交易发生在线支付时，本平台接受卖方委托通过淘号号极速版钱包账户代为收取交易款项，并在买方在线确认“已收货”或本平台约定的交易期限届满时接受买方委托将该交易款项支付至卖方淘号号极速版钱包账户，或卖方确认该笔交易已取消时接受卖方委托将该交易款项退回至买方原支付账户或淘号号极速版钱包。在线交易双方就交易事项无法达成一致意见期间，交易双方一致同意由淘号号极速版将该笔交易款项暂时冻结在淘号号极速版账户直至双方达成一致意见并根据双方的共同意愿支付。特殊情形下，淘号号极速版将可能在您付款且点击确认购买/发货后通过系统自动付款给卖方，具体以平台页面展示为准，请您注意审慎阅读相应的付款规则，点击确认购买/确认发货即视为您接受相应的付款规则并委托淘号号极速版代付交易款项给卖方。交易双方用户同意，淘号号极速版钱包账户代付后，非经法律程序或者本协议之约定, 该支付是不可撤销的，淘号号极速版的支付行为视为经买卖双方的共同授权代为支付的行为。</div>
  
  <div>
  6、用户知悉并同意，平台担保服务仅为防止买卖双方因脱离平台支付导致的欺诈被骗、敲诈勒索等人身及钱财损失的情形，并非淘号号极速版对交易任一方做出的任何关于商品及交易情况的言行进行审核并提供质量或者履行能力相关的担保或保证，交易双方应自行对交易行为承担全部责任。
  </div><div>7、您知悉并了解，对于本平台所展示的商品，除买卖双方另有约定及商品/服务确实存在与卖方描述不一致的质量问题外，概不支持无理由退货。且鉴于资产/服务交易纠纷及风险高于普通物品/服务交易，淘号号极速版用户需在淘号号极速版内对交易细节进行详细、客观的沟通约定，并遵守相应的约定事项。若因交易约定不详导致的交易纠纷，除法律另有明确规定外，由淘号号极速版用户自行承担风险和责任。
  </div>
  
  <div>8、您知悉并了解，鉴于脱离平台交易存在较大的人身财产安全及交易纠纷风险，淘号号极速版推荐您使用淘号号极速版平台担保交易服务。如您脱离平台担保交易而选择私下交易（包括但不限于添加微信、QQ或者支付宝等第三方社交/支付工具）的，如因脱离平台交易产生纠纷及风险，除法律另有明确规定外，由您自行承担全部损失和责任。您理解并同意，此等情况下，淘号号极速版仅作为单纯的信息发布平台，既未参与双方的交易过程，亦未就交易活动收取费用，对您因脱离平台交易产生的纠纷/责任/索赔等免责。</div>
  <div>
  9、用户在淘号号极速版上交易过程中如与其他用户因交易产生争议/纠纷的，可以选择以下途径解决：
  </div><div>（1）与争议相对方自主协商；
  </div><div>（2）使用淘号号极速版平台提供的争议调处（亦称“客服介入”）服务；
  </div><div>（3）请求消费者协会或者其他依法成立的调解组织调解；
  </div><div>（4）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；
  </div><div>（5）向人民法院提起诉讼。
  </div>
  <div>10、如您依据淘号号极速版相关规则选择使用淘号号极速版提供的争议调处服务或基于交易方申请而进入到争议调处程序，则表示您认可并愿意履行淘号号极速版客服作为独立的第三方根据其所了解到的争议事实并依据淘号号极速版相关规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。您知悉并同意：淘号号极速版客服介入做出的调处决定并非国家公权力机关的终局裁决，您仍有权利就交易纠纷采取其他合法途径维护您的合法权益。在淘号号极速版平台调处决定作出前，您可选择本协议第5.11条第（3）、（4）、（5）途径（下称“其他争议处理途径”）解决争议以中止淘号号极速版平台的争议调处服务。在淘号号极速版平台调处决定做出后，如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。淘号号极速版不保证争议处理结果符合您的期望，除因淘号号极速版单方原因故意或重大过失导致您产生损失的情况外，淘号号极速版不对淘号号极速版依据淘号号极速版相关规则做出的争议处理结果承担责任。
  </div>
  
  <div class="title-div top20">第六条 用户权利和义务</div>
  <div>
  1、您在使用淘号号极速版平台服务时，您需要凭您的手机号、微信授权登录许可软件并绑定合法有效的手机号码。淘号号极速版将根据您提交的信息（如身份信息、微信账户和绑定的手机号码信息等，且身份信息优先适用）确认使用许可软件者的身份。您应妥善保管您的微信账户、手机号码和验证码，并对其使用或遗失自行承担责任。淘号号极速版账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，淘号号极速版并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</div>
  
  <div>
  2、如果您的微信账户和手机号码存在未获授权的使用，或者发生其他任何安全问题时，建议您立即通知淘号号极速版。除法律另有明确规定外，淘号号极速版对因上述情形产生的后果不承担责任。您理解淘号号极速版对您的任何请求采取行动均需要合理时间，且淘号号极速版应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除淘号号极速版存在法定过错外，淘号号极速版不承担责任。</div>
  
  <div>
  3、如淘号号极速版按您最后一次提供的信息与您联系未果、您未按淘号号极速版的要求及时提供/更新信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及淘号号极速版造成的全部损失与不利后果。淘号号极速版可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部淘号号极速版平台服务，淘号号极速版对此不承担责任。
  </div><div>4、用户保证不以他人资料在淘号号极速版进行注册（包括但不限于使用他人的微信账户或者手机号码或者身份信息）、认证、登录，否则由此产生的全部不利责任将全部由用户自身承担；除淘号号极速版存在法定过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。用户理解并同意，淘号号极速版有权应政府部门（包括司法及行政部门）的要求，向其提供用户在淘号号极速版填写的注册信息和交易记录等必要信息。
  </div>
  <div>5、为了确保用户身份信息的真实及持续有效，淘号号极速版会在不同场景中要求您进行实人认证（实人认证是由淘号号极速版合作的第三方提供的一项个人身份认证服务，通过与公安网数据校验并使用全球领先的人脸识别技术，保障个人身份真实性）或者进行市场主体资质认证，您不得使用虚假或者无效的信息进行认证或从事其他违反国家法律法规和平台规则的活动。
  </div><div>6、您需全面、真实、准确、及时地披露商品/服务信息以保障交易相对方的知情权和选择权；您应确保自己对在淘号号极速版发布的内容系您原创或已获得有效、完全的授权，并与实际一致，不会侵犯任何主体的肖像权、名誉权、知识产权、隐私权等合法权益，也不会侵犯法人或其他团体的商标权、商业秘密等合法权益，不违反国家法律法规及本平台的规定。如因此引起纠纷，淘号号极速版有权直接立即删除或屏蔽该内容，判定交易不成立，并要求您赔偿给本平台造成的全部损失。
  </div><div>7、您应确保您通过淘号号极速版提交、发布的全部信息（包括但不限于个人信息、商品信息、言论及所作出的行为等）不包含以下内容，否则淘号号极速版有权对您的账户进行处理。因此导致第三方用户或淘号号极速版损失的，您应承担全部赔偿责任。</div>
  
  <div>
  </div><div>（1）违反国家法律法规、破坏国家统一、煽动民族仇恨、民族歧视、破坏民族团结的；
  </div><div>（2）损害国家机关信誉、进行政治宣传或破坏国家宗教政策的；
  </div><div>（3）宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的；
  </div><div>（4）侮辱、诽谤、恐吓、散播涉及他人隐私等侵害他人合法权益的；
  </div><div>（5）捏造、歪曲或掩盖事实，从事欺诈、虚假、不准确或误导性行为，扰乱社会秩序、平台交易秩序的；
  </div><div>（6）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
  </div><div>（7）存在可能破坏、篡改、删除、影响淘号号极速版任何系统正常运行或未经授权秘密获取淘号号极速版及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
  </div><div>（8）其他违背社会公共利益或公共道德的。
  </div>
  <div>8、淘号号极速版平台只允许每位用户使用一个淘号号极速版平台账户。用户不得通过任何手段恶意注册淘号号极速版帐号，包括但不限于以牟利、炒作、套现、获奖等为目的多个账号注册；不得盗用其他用户帐号；未经淘号号极速版明确书面许可，亦不得转让、出租或者售卖淘号号极速版账号。如有证据证明或淘号号极速版平台有理由相信您存在不当注册或不当使用多个淘号号极速版平台账户的情形，淘号号极速版有权直接采取一切必要的措施，包括但不限于删除用户发布的内容、取消用户在平台获得的星级、荣誉以及虚拟财富，暂停、查封、冻结或关闭用户帐号，取消交易及因违规所获利益，拒绝提供服务等，乃至通过诉讼形式追究用户法律责任等。如给淘号号极速版平台及相关方造成损失的，您还应承担赔偿责任。
  </div><div>9、用户应当保证在使用淘号号极速版平台进行交易的过程中遵守国家法律法规等规范文件及淘号号极速版平台各项规则的规定和要求，不得在交易产生后以牟利或借机进行敲诈勒索为目的的恶意行为，不损害他人的合法权益，不在交易过程中采取不正当竞争行为或其他明显违反平台、公平、自愿等交易原则的违法违规行为，不扰乱网上交易的正常秩序，不从事与交易无关的行为。</div>
  <div>
  10、用户在使用淘号号极速版服务过程中所产生应纳税费（含发票开具等），以及其他相关费用，均由用户独自承担。除淘号号极速版平台自营以外，买方通过淘号号极速版平台向淘号号极速版平台卖方购买商品或服务的，有权向卖方索取发票，卖方有义务按照法律规定向买方提供发票凭证，与淘号号极速版平台无关。用户如发现其他用户有违法或违反本协议的行为，可以向淘号号极速版进行反映并建议处理。</div>
  
  <div>
  11、为有效控制和防范资产或回收及销售过程中的潜在刑事法律风险，并积极履行协助和配合公安机关打击犯罪的义务，如所购商品用于自用，用户不得用任何手段恢复和泄露商品内的任何信息，且应承担信息泄露的一切后果和责任；如所购商品用于二次销售，用户应当严格记录商品的销售交易信息，并对该信息至少保存两年。用户应当记录并保存的交易信息包括但不限于：（1）出售电子商品的信息，包括IMEI码；（2）购买用户的身份信息，包括姓名、身份证号、联系电话。如若用户购买的商品因涉嫌刑事犯罪被公安机关追赃，用户应全力协助公安机关追回涉案商品。涉案商品追回的，平台将协助督促物主向用户全额退还该商品的成交金额，但若因用户未履行交易信息登记和保存义务而导致涉案商品无法追回，用户应自行承担相关经济损失。
  
  </div>
  <div class="title-div top20">第七条  淘号号极速版的权利和义务</div>
  <div>
  1、对于用户在淘号号极速版平台上的不当行为或其它任何淘号号极速版认为应当终止服务的情况，淘号号极速版有权随时作出删除相关信息、终止服务等处理，而无须征得用户的同意。 
  </div>
  <div>2、凡有用户恶意注册（为达到某种不正当的目的，进行非正常注册）淘号号极速版帐号或产生作弊/虚假交易（如刷单、炒信等）一经发现，淘号号极速版均有权取消该用户在本平台的一切权利、权益，包括但不限于注销该用户相关信息、冻结其帐号、停止所有服务等处理，而无须征得用户的同意，因此造成的全部后果和损失由用户独立承担。</div>
  
  <div>
  3、因淘号号极速版平台的特殊性，淘号号极速版对所有用户的注册登录信息会进行审核，但仅限于手机号码、微信账号的审核，以及主体身份信息的审核，如存在下列情况之一的，淘号号极速版有权根据不同情况选择保留或删除相关信息或继续、停止对该用户提供服务，并追究相关法律责任。
  </div><div>（1）用户或其它第三方通知淘号号极速版，认为某个具体用户或具体事项可能存在重大问题；
  </div><div>（2）用户或其他第三方向淘号号极速版投诉举证淘号号极速版平台上有违法或不当行为的，淘号号极速版以普通非专业知识水平标准对相关内容进行判别，可以明显认为这些内容或行为具有违法或不当性质的。
  </div>
  <div>4、经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者淘号号极速版有足够事实依据可以认定用户存在违法或违反服务协议行为的，淘号号极速版有权在淘号号极速版平台及所在网站上以网络发布形式公布用户的违法行为，以提示其他用户注意判断评估交易风险。
  </div><div>5、对于用户在淘号号极速版平台发布的部分不合理信息，淘号号极速版有权在不通知用户的前提下进行删除、屏蔽或采取其它限制性措施。此类不合理信息包括但不限于：</div>
  
  <div>
  </div><div>①以进行商业代购或商业买卖为目的信息；
  </div><div>②以炒作不实信用为目的的信息；
  </div><div>③淘号号极速版有理由相信存在欺诈等恶意或虚假内容的信息；
  </div><div>④淘号号极速版有理由相信与资产/服务转让无关或不是以转让为目的的信息；
  </div><div>⑤淘号号极速版有理由相信存在恶意扰乱正常淘号号极速版秩序因素的信息；
  </div><div>⑥淘号号极速版有理由相信该信息违反公共利益或可能严重损害淘号号极速版和其它用户合法利益的。
  </div>
  <div>6、淘号号极速版有权将具备关联关系的用户进行统一管理，形成关联圈。前述关联关系是指不同用户账号下用户提供的手机号码、联系方式、身份证件、银行卡、支付账号、终端设备等任一信息相同均视为关联用户。淘号号极速版有权对关联圈内的账户进行统一管理，包括但不限于统一限制发布或者下架商品，统一限制账户功能如禁止私信沟通/留言、阻止交易，统一中止/终止平台服务等。
  </div>
  <div>7、若关联圈中的任一用户存在违反相关法律法规、本协议、平台规则的情形，淘号号极速版有权无需通知立即暂停该用户账号及其关联账户的部分或全部功能，并依据本协议或平台规则对涉嫌违规账户及其关联账户统一采取处理措施，该等处理措施包括但不限于：
  </div><div>1) 要求用户对关联圈内各账号间的关联关系作出正式的书面解释；
  </div><div>2) 解除本协议；
  </div><div>3)搜索降权、下架、禁售、禁止上新、禁止上架；
  </div><div>4)直接扣划账户项下资金冲抵赔付金及违约账号应承担的其他款项或费用；
  </div><div>5) 限制账号主体使用其信息注册其他淘号号极速版账号；
  </div><div>6) 平台规则规定的其他违规处理措施。</div>
  <div class="title-div top20">第八条  拒绝担保和责任范围</div>
  <div>
  1、本协议项下，淘号号极速版将按“现状”和“可得到”的状态向用户提供淘号号极速版服务，将在现有技术的基础上尽最大努力提供相应的安全措施以保障服务安全和正常运行。淘号号极速版不对淘号号极速版服务所涉及的技术及信息的是否有效、准确、正确、可靠以及其质量、稳定、完整和及时性作出任何承诺和保证；亦对淘号号极速版服务不作任何明示或暗示的保证，包括但不限于淘号号极速版服务的是否适用、是否存在错误或疏漏、是否具有持续、准确、可靠等性能、是否适用于某一特定用途等。
  </div>
  <div>2、淘号号极速版仅向您提供淘号号极速版平台服务，您了解淘号号极速版平台上的信息系用户自行发布，且可能存在风险和瑕疵。淘号号极速版将通过依法建立相关检查监控制度尽可能保障您在淘号号极速版平台上的合法权益及良好体验。同时，鉴于淘号号极速版平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，淘号号极速版无法逐一审查商品或服务的信息，无法逐一审查交易所涉及的商品或服务的质量、安全以及合法性，商品信息的真实性、准确性及合法性，对此您应谨慎判断确定相关信息的真实性、合法性和有效性，并注意保留相应的证据以利于维权，并尽量采用淘号号极速版建议的交易方式进行交易，以避免造成人身财产损失。</div>
  <div>3、淘号号极速版仅作为资产或服务信息发布及交易平台，仅作为您获取物品或者服务信息、物色交易对象、就物品或服务的交易进行协商及开展交易的场所，淘号号极速版并不作为交易双方之任何一方的身份参与交易物品行为，无法控制交易物品所涉及的物品的质量、安全或合法性，商品信息的真实性或准确性，以及交易各方履行其在交易协议中各项义务的能力。本协议的签署并不意味着淘号号极速版为淘号号极速版平台上交易双方的行为合法性、有效性及货品的真实性、合法性、有效性提供任何明示或暗示的担保或承诺。</div>
  <div>
  4、淘号号极速版平台与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：
  </div><div>（1）其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的，或者含有淫秽、色情、下流、反动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；
  </div><div>（2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料；
  </div><div>（3）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。
  您充分了解并同意：上述的各种不良信息、网络安全和网络故障问题，并不是淘号号极速版或者淘号号极速版平台所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，概由您自行承担，淘号号极速版无须向您承担任何责任。
  </div><div>5、用户明确理解和同意，淘号号极速版不对以下述任一情况而导致的任何损害赔偿承担责任，包括但不限于商誉、使用、数据、利润等方面的损失或其它无形损失的损害赔偿 (无论淘号号极速版是否已被告知该等损害赔偿的可能性)：
  </div><div>（1）第三方未经批准的接入或更改用户的传输数据或数据；
  </div><div>（2）通过淘号号极速版平台服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；
  </div><div>（3）第三方对“服务”的声明或关于“服务”的行为；或非因淘号号极速版的原因而引起的与“服务”有关的任何其它事宜，包括疏忽。
  </div><div>（4）您对淘号号极速版平台服务的误解；
  </div><div>（5）任何非因淘号号极速版的原因而引起的与淘号号极速版平台服务有关的其它损失。
  </div><div>6、所有发给用户的通告，淘号号极速版都将通过正式的页面公告、站内信、客服电话、手机短信或常规信件送达。任何非经淘号号极速版正规渠道获得的中奖、优惠等活动或信息，淘号号极速版不承担法律责任。用户明确理解并同意，如因其违反有关法律或者本协议之规定，使淘号号极速版遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对淘号号极速版提供补偿，包括合理的律师费用。</div>
  
  <div class="title-div top20">第九条  侵权投诉</div>
  <div>
  1、据《中华人民共和国侵权责任法》第三十六条，任何第三方认为，用户利用淘号号极速版平台侵害本人民事权益或实施侵权行为的，包括但不限于侮辱、诽谤等，被侵权人有权书面通知淘号号极速版采取删除、屏蔽、断开链接等必要措施。
  </div>
  <div>2、任何第三方（包括但不限于企业、单位或个人等）认为淘号号极速版用户发布的任何信息侵犯其合法权益的，在有充分法律法规及证据足以证明的情况下，可以通过淘号号极速版右下角“我的”—客服中心联系在线客服告知。</div>
  <div>
  3、侵权投诉必须包含以下信息：
  </div><div>（1）被侵权人的姓名（名称）、联系方式、电子邮件等；
  </div><div>（2）侵权的具体信息网址、编号或其他可以找到该信息的细节；
  </div><div>（3）您是所述的版权或者其他权利的合法拥有者的权利证明；
  </div><div>（4）您的身份证复印件、营业执照等其他相关资料。
  </div><div>（5）投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该对象侵害本人或他人的合法权益。本人承诺投诉全部信息真实、准确，否则自愿承担一切后果。”
  </div><div>（6）本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。
  </div>
  <div>4、权利人应当对通知书的真实性负责。淘号号极速版用户在提起投诉之前应咨询法律顾问或律师。我们提请权利人注意：如果对侵权投诉不实，则可能承担相应的法律责任。在淘号号极速版将被投诉方提交的不存在侵权行为的声明转交给权利人后十五日内，未收到权利人已经投诉或者起诉通知的，淘号号极速版有权及时终止所采取的措施。</div>
  
  <div class="title-div top20">第十条 信息获取及保护</div>
  <div>
  </div><div>1、淘号号极速版非常重视用户个人信息（即以电子或者其他方式记录的能够单独或与其他信息结合识别特定用户身份的信息）保护，在您使用淘号号极速版提供的服务时，您同意遵守淘号号极速版平台公布并不时修订的隐私权条款，淘号号极速版隐私权条款构成本协议的有效组成部分，亦同意淘号号极速版按照隐私权条款收集、存储、使用、披露和保护您的个人信息。
  </div><div>2、您知悉并同意，为向您提供更安全的服务，在适用法律允许的范围内，淘号号极速版可能为安全目的采取必要的技术手段获取您在使用淘号号极速版过程中的相关信息。
  </div><div>3、淘号号极速版要求各搜索引擎遵循行业规范，即“拒绝 Robots 访问标准”(Robots Exclusion Standard)，否则将视你的抓取行为是对淘号号极速版平台财产权利和知识产权的侵犯，淘号号极速版有权通过法律诉讼维护平台利益。
  
  </div>
  
  <div class="title-div top20">第十一条  知识产权保护</div>
  
  <div>1、任何用户接受本协议，即表明该用户主动将其在任何时间段在本平台上传、发布的任何形式的信息内容（包括但不限于图片、音频、视频、商品咨询及评价、各类话题文章等）的财产性权利等任何可转让的权利，如著作财产权，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等，以及应当由著作权人享有的其他可转让权利无偿独家且不可撤销地转让给淘号号极速版运营者所有，同时表明该用户许可淘号号极速版有权利就任何主体侵权而单独提起诉讼，并获得全部赔偿。本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律所规定的著作财产权等权利转让书面协议，其效力及于用户在淘号号极速版发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。用户同意并明确了解上述条款，不将已发表于本平台的信息，以任何形式发布或授权其它网站（及媒体）使用。</div>
  <div>
  </div><div>2、淘号号极速版许可软件的一切版权、商标权、专利权、商业秘密以及与淘号号极速版相关的所有信息内容包括但不限于作品、图片、文字表述及其组合、音频、视频、图标、档案资料、网站构架、网站版面框架、网页设计、有关数据、印刷材料、电子文档等，均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应国际条约以及其他知识产权法律法规的保护，除涉及第三方授权的软件或技术外，淘号号极速版享有上述知识产权。未经淘号号极速版书面同意，任何人不得为任何营利性或非营利性的目的自行使用（包括但不限于以非法方式复制、传播、展示、镜像、上载、下载、修改、出租、出借、出售、散布淘号号极速版平台的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品）、转让或者许可任何第三方使用、转让上述知识产权。淘号号极速版保留追究上述未经许可行为的法律责任的权利。
  </div><div>3、本公司是淘号号极速版平台的制作者,拥有此平台内容及资源的版权，受国家知识产权保护，享有对本平台各种协议、声明的修改权；本平台上所有内容的汇编是淘号号极速版的排他财产，受中国和国际版权法的保护。除法律另有强制性规定外，未经淘号号极速版的明确书面许可，任何第三方不得为任何私人或商业目的获取或使用本平台的任何部分或通过本平台可直接或间接获得的任何内容、服务或资料。任何第三方违反本协议的规定以任何方式，和/或以任何文字对本平台的任何部分进行发表、复制、转载、更改、引用、链接、下载、抓取或以其他方式进行使用，或向任何其他第三方提供获取本平台任何内容的渠道，则对本平台的使用权将立即终止，且任何第三方必须按照本公司的要求，归还或销毁使用本平台任何部分的内容所创建的资料的任何副本。
  </div><div>4、淘号号极速版未向任何第三方转让本网站或其中的任何内容所相关的任何权益或所有权，且一切未明确向任何第三方授予的权利均归淘号号极速版所有。未经本协议明确允许而擅自使用本平台任何内容、服务或资料的，构成对本协议的违约行为，且可能触犯著作权、商标、专利和/或其他方面的法律法规，淘号号极速版保留对任何违反本协议规定的第三方（包括单位或个人等）提起法律诉讼的权利。
  </div>
  <div class="title-div top20">第十二条 违约责任</div>
  <div>
  1、您应理解按本协议约定使用淘号号极速版，按规范使用许可软件、按本协议约定履行义务是您获取淘号号极速版授权使用软件、提供淘号号极速版服务的前提，如您严重违反本协议，淘号号极速版将终止提供服务，本协议终止。在本使用许可终止时，您应停止对许可软件的使用行为, 并销毁许可软件的全部副本。您在协议终止前的行为所导致的任何责任，您应完全且独立地承担。
  </div>
  <div>2、一旦您违反本协议任意条款，淘号号极速版有权对您的权益采取限制措施，包括中止、终止对您提供部分或全部服务。您在淘号号极速版平台上发布的信息构成违约的，淘号号极速版可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的商品进行下架、监管。您在淘号号极速版平台上实施的行为，或虽未在淘号号极速版平台上实施但对淘号号极速版平台及其用户产生影响的行为构成违约的，淘号号极速版可依据相应规则对您执行账户扣分、限制参加营销活动、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，淘号号极速版可查封您的账户，终止向您提供服务。
  </div><div>3、如您违反法律法规或本协议约定的条款，给其他用户造成损失或使淘号号极速版遭受任何损失/受到任何第三方的索赔/受到任何行政管理部门的处罚的，您必须承担全部的赔偿责任。如淘号号极速版因此向第三方进行了赔偿或补偿，则您同意赔偿淘号号极速版的相关支出和损失，包括合理的律师费用。同时，淘号号极速版有权依据本协议的约定，对用户的账户及发布的信息做出相应处理措施，包括但不限于直接屏蔽、删除侵权信息或直接关闭账号、停止服务，且无须征得您的同意或提前通知您。</div>
  <div>
  4、淘号号极速版有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。对于用户涉嫌违反本协议承诺/约定的行为对任意第三方造成损害的，用户均应当以自己的名义独立承担所有的法律责任，并应确保淘号号极速版免于承担因此产生的损失或增加的费用。
  
  </div>
  
  <div class="title-div top20">第十三条 协议终止</div>
  <div>
  1、您有权通过以下任一方式终止本协议：
  </div><div>（一）在满足淘号号极速版平台公示的账户注销条件时您通过网站服务注销您的账户的；
  </div><div>（二）变更事项生效前您停止使用并明示不愿接受变更事项的；
  </div><div>（三）您明示不愿继续使用淘号号极速版平台服务，且符合淘号号极速版平台终止条件的。 
  </div><div>2、出现以下情况时，淘号号极速版可以本协议第十四条所列的方式通知您终止本协议：
  </div><div>（一）您违反本协议约定，淘号号极速版依据违约条款终止本协议的；
  </div><div>（二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，淘号号极速版依据淘号号极速版平台规则对您的账户予以查封的；
  </div><div>（三）除上述情形外，因您多次违反淘号号极速版平台规则相关规定且情节严重，淘号号极速版依据淘号号极速版平台规则对您的账户予以查封的；
  </div><div>（四）您的账户被淘号号极速版依据本协议回收的；
  </div><div>（五）您在淘号号极速版平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；
  </div><div>（六）其它应当终止服务的情况。</div>
  <div>3、本协议终止后，除法律有明确规定外，淘号号极速版无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，淘号号极速版仍享有下列权利：</div>
  <div>
  </div><div>（一）继续保存您留存于淘号号极速版平台的各类信息；
  </div><div>（二）对于您过往的违约行为，淘号号极速版仍可依据本协议向您追究违约责任。
  </div>
  <div>4、本协议终止后，对于您在本协议存续期间产生的交易订单，淘号号极速版可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
  </div>
  
  <div class="title-div top20">第十四条  通知</div>
  <div>
  1、您在注册成为淘号号极速版平台用户，并接受淘号号极速版平台服务时，您应该向淘号号极速版提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。您在注册淘号号极速版平台用户时生成的用于登陆淘号号极速版平台接收站内信、系统消息和私信息的账号，也作为您的有效联系方式。
  </div>
  <div>2、淘号号极速版将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
  </div><div>3、淘号号极速版通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在淘号号极速版平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送私信信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第三个自然日即视为送达。
  </div><div>4、对于在淘号号极速版平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件或淘号号极速版私信等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱或淘号号极速版私信等联系方式为您在淘号号极速版平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册淘号号极速版用户时生成淘号号极速版账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</div>
  <div>
  5、您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
  </div>
  <div>6、你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</div>
  
  
  <div class="title-div top20">第十五条  其他约定</div>
  <div>
  1、本协议适用中华人民共和国大陆地区法律。您因使用淘号号极速版平台服务所产生及与淘号号极速版平台服务有关的争议或纠纷，由淘号号极速版或其关联方与您友好协商解决；协商不成的，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</div>
  <div>
  2、任一方未经对方同意，不得将协议权利义务转让第三方。淘号号极速版可基于服务需要，变更或增加履约主体，此等变更不会影响您在本协议项下的权益。如您继续使用淘号号极速版服务的，视为同意变更后的主体或新增的主体作为与您履约的相对方。上述主体的变更淘号号极速版将通过页面公告等方式向您发出通知。
  </div><div>3、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</div>
  
  
  
  </div>
    </div>
  </template>
  
  <script>
  
  </script>
  
  <style scoped>
  .title-div {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .center {
    text-align: center;
  }
  .top {
    margin-top: 10px;
  }
  .top20 {
    margin-top: 20px;
  }
  .content-div {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 20px;
  }
  .bodder-div {
    padding: 24px 14px;
  }
  </style>
  